import { Controller } from "@hotwired/stimulus"

// Submits the surrounding form when a field changes, for selects that apply
// immediately (e.g. the member-role select in the folder members dialog).
// Attach to the form; wire fields with data-action="change->auto-submit#submit".
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
